class WebserviceError extends Error {
    constructor(errorMessage, data) {
        super(errorMessage);
        this.data = data;

        this.name = 'WebserviceError';
    }
}

angular
    .module('WizApp')
    .factory('ErrorFactory', [
        function () {
            return {
                newWebserviceError(errorMessage, data) {
                    return new WebserviceError(errorMessage, data);
                },

                isWebserviceError(error) {
                    return error.name === WebserviceError.name;
                }
            };
        }
    ]);
